import axios from "axios";

export default {
  namespaced: true,
  state: {
    id: '',                //教室ID
    name: '',              //教室名
    useStartOn: '',        //利用開始日
    useEndOn: '',          //利用終了日
    agreementUpdateOn: '', //前回契約更新日
    agreementEndOn: '',    //契約終了日
    tel: '',               //教室電話番号
    representative: '',    //教室担当者氏名
    email: '',             //教室担当者メールアドレス
    userId: '',            //ユーザーID
    login: '',             //ログインID
    password: '',          //パスワード
    sendMail: false,         //メール送信
    classroomValid: true,     //教室情報の入力不備
    status: 'new'
  },

  getters: {
    title: state => {
      return state.id ? '編集' : '新規作成'
    },
    isEdit: state => {
      return state.id ? true : false
    },
    passwordLabel: state => {
      return state.id ? 'パスワード再設定' : 'パスワード'
    },
    url: state => {
      return state.id
        ? `api/v1/admin/branches/${state.id}`
        : 'api/v1/admin/branches'
    },
    method: state => {
      return state.id ? 'PUT' : 'POST'
    },
    data( state, getters, rootState ) {
      return {
        customerId:        rootState.school.id,     //塾ID
        name:              state.name,              //教室名
        useStartOn:        state.useStartOn,        //利用開始日
        useEndOn:          state.useEndOn,          //利用終了日
        agreementUpdateOn: state.agreementUpdateOn, //前回契約更新日
        agreementEndOn:    state.agreementEndOn,    //契約終了日
        tel:               state.tel,               //教室電話番号
        representative:    state.representative,    //教室担当者氏名
        email:             state.email,             //教室担当者メールアドレス
        usersAttributes: [                          //ユーザー情報配列
          {
            id: state.userId,
            'login': state.login,
            'password': state.password
          }
        ],
      };
    },
  },

  mutations: {
    setId(state, payload) {
      state.id = payload.id;
    },
    setName(state, payload) {
      state.name = payload.name;
    },
    setUseStartOn(state, payload) {
      state.useStartOn = payload.useStartOn;
    },
    setUseEndOn(state, payload) {
      state.useEndOn = payload.useEndOn;
    },
    setAgreementUpdateOn(state, payload) {
      state.agreementUpdateOn = payload.agreementUpdateOn;
    },
    setAgreementEndOn(state, payload) {
      state.agreementEndOn = payload.agreementEndOn;
    },
    setTel(state, payload) {
      state.tel = payload.tel;
    },
    setRepresentative(state, payload) {
      state.representative = payload.representative;
    },
    setMail(state, payload) {
      state.email = payload.email;
    },
    setLogin(state, payload) {
      state.login = payload.login
    },
    setPassword(state, payload) {
      state.password = payload.password
    },
    setSendMail(state, payload) {
      state.sendMail = payload.sendMail
    },
    setClassroomValid(state, payload) {
      state.classroomValid = payload.valid
    },
    setAccount(state, payload) {
      if (payload.id) {
        state.id                = payload.id;
        state.name              = payload.name;
        state.useStartOn        = payload.useStartOn;
        state.useEndOn          = payload.useEndOn;
        state.agreementUpdateOn = payload.agreementUpdateOn;
        state.agreementEndOn    = payload.agreementEndOn;
        state.tel               = payload.tel;
        state.representative    = payload.representative;
        state.email             = payload.email;
        state.userId            = payload.users[0].id;
        state.login             = payload.users[0].login;
      } else {
        Object.assign(state, payload)
      }
    },
    setStatus(state, payload) {
      state.status = payload.status
    },
    initialize(state) {
      state.id                = '';
      state.name              = '';
      state.useStartOn        = '';
      state.useEndOn          = '';
      state.agreementUpdateOn = '';
      state.agreementEndOn    = '';
      state.tel               = '';
      state.representative    = '';
      state.email             = '';
      state.userId            = ''
      state.login             = '';
      state.password          = '';
      state.sendMail          = false;
    },
  },

  actions: {
    async submit({ state, getters }) {
      const branch  = getters.data
      const url     = getters.url
      const method  = getters.method
      const title   = getters.title
      await axios({
        url: url,
        method: method,
        data: {
          branch: branch,
          sendMail: state.sendMail,
        },
      })
      return {message: `${title}が完了しました` }
    },
  },
}
